<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>
            <fieldset class="tw-px-8 tw-pb-3 tw-pt-5 lg:tw-pt-5 lg:tw-px-12 lg:tw-pb-6">
                <div class="step" v-if="step === 1">
                    <div class="question"><p class="animal tw-uppercase">O seu animal é?</p></div>
                    <div class="tw-flex tw-items-center tw-justify-center tw-w-full tw-gap-8 tw-mb-3">
                        <div @click="type = 'Cao'" class="animal-type tw-flex tw-items-center tw-justify-center tw-gap-3" :class="{ 'active' : type == 'Cao' }">
                            <img src="~@/assets/img/dog.png">
                            <small>Cão</small>
                        </div>
                        <div @click="type = 'Gato'" class="animal-type tw-flex tw-items-center tw-justify-center tw-gap-3" :class="{ 'active' : type == 'Gato' }">
                            <img src="~@/assets/img/cat.png">
                            <small>Gato</small>
                        </div>
                    </div>
                    <div class="question">
                        <p class="tw-uppercase"><span>Que idade tem o seu animal?</span></p>
                        <p style="font-size: 13px;color: rgb(170, 170, 170);font-family: Barlow, Helvetica Neue, Helvetica, Arial, sans-serif;font-weight: 500;">Seguro válido para pets com idade igual ou inferior a 8 anos</p>
                    </div>
                    <div class="range-slider-container">
                        <div class="range-info">
                            <p v-if="rangeValue == '1'">Entre <span>2</span> e <span>6</span> meses</p>
                            <p v-if="rangeValue == '2'">Entre <span>6</span> meses e <span>1,5</span> anos</p>
                            <p v-if="rangeValue == '3'">Entre <span>1,5</span> anos e <span>2</span> anos</p>
                            <p v-if="rangeValue == '4'">Entre <span>2</span> anos e <span>4</span> anos</p>
                            <p v-if="rangeValue == '5'">Entre <span>4</span> anos e <span>7</span> anos</p>
                            <p v-if="rangeValue == '6'">Entre <span>7</span> anos e <span>8</span> anos</p>
                        </div>
                        <div class="range-ticks">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                        <range-slider
                            class="slider"
                            min="1"
                            max="6"
                            v-model="rangeValue"
                            @change="changePetInfo"
                        >
                        </range-slider>
                    </div>
                    <div class="legals tw-mt-5">
                        <h4>Por que precisamos dos seus dados?</h4>
                        <p class="legals">Os dados pessoais por si acima facultados serão tratados <strong>para posterior contacto telefónico com a finalidade de realizar a simulação</strong> e para fazer o acompanhamento comercial da mesma, com fundamento no desenvolvimento de diligências pré-contratuais a pedido do titular e no interesse legítimo do desenvolvimento da atividade comercial da Fidelidade.</p><br>
                        <a href="https://www.fidelidade.pt/PT/protecao-dados/Documents/Politica_de_Privacidade_e_Protecao_de_Dados_Pessoais%E2%80%93FIDELIDADE.pdf" target="_blank"><legend>Consulte aqui, informação mais detalhada sobre proteção e tratamento dos seus dados pela Fidelidade.</legend></a>
                    </div>
                    <div class="tw-text-center tw-mt-4">
                        <button class="btn-cta" @click.prevent="step++;"><span>CONTINUAR</span></button>
                    </div>
                </div>
                <div class="step" v-if="step === 2">
                    <div class="tw-flex tw-gap-6 tw-justify-between tw-w-full tw-pt-0 lg:tw-pt-2">
                        <!-- <div class="question client"><p><small>Já é cliente Fidelidade?</small></p></div>
                        <validation-provider class="tw-w-block client-q" name="client" rules="required" v-slot="{ classes }">
                            <div class="input-group input-group-client">
                                <div class="form-check tw-flex tw-items-center tw-justify-center tw-gap-4 tw-pt-1">
                                    <label class="form-check-label tw-relative" :class="classes">
                                        <input class="form-check-input" type="radio" value="1" v-model="client">
                                        <span class="checkmark"></span>
                                        <span class="tw-font-normal tw-pl-2 tw-text-sm lg:tw-text-base">Sim</span>
                                    </label>
                                    <label class="form-check-label tw-relative" :class="classes">
                                        <input class="form-check-input tw-hidden" type="radio" value="0" v-model="client">
                                        <span class="checkmark"></span>
                                        <span class="tw-font-normal tw-pl-2 tw-text-sm lg:tw-text-base">Não</span>
                                    </label>
                                </div>
                            </div>
                        </validation-provider> -->
                        <p class="step-2-title tw-mx-auto tw-block tw-uppercase tw-font-bold">Preencha o formulário</p>
                    </div>
                    <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
                        <div class="input-group input-group-name" :class="classes">
                            <input type="text"
                                id="input-fullName"
                                placeholder=" "
                                v-model="fullName"
                            >
                            <label>
                                Nome
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'inválido' }">
                        <div class="input-group input-group-email" :class="classes">
                            <input type="email"
                                id="input-email"
                                placeholder=" "
                                v-model.lazy="email"
                            >
                            <label>
                                Email {{ errors [0]}}
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="nif" rules="required|nif" v-slot="{ classes }">
                        <div class="input-group input-group-nif" :class="classes">
                            <input type="tel"
                                id="input-nif"
                                placeholder=" "
                                v-model="nif"
                                v-mask="{mask: '999999999', placeholder: ' '}"
                            >
                            <label>
                                NIF
                            </label>
                        </div>
                    </validation-provider>
                    <div class="tw-flex tw-flex-col tw-gap-0 lg:tw-gap-3 lg:tw-flex-row">
                        <validation-provider class="tw-w-full tw-w-block" name="zip" rules="required|zip:pt" v-slot="{ classes }" :key="'inputzip'">
                            <div class="input-group input-group-zip" :class="classes">
                                <input type="tel"
                                    id="input-phone"
                                    placeholder=" "
                                    v-model="zip"
                                    v-mask="{mask: '9999-999', placeholder: ' '}"
                                >
                                <label>
                                    Código Postal
                                </label>
                            </div>
                        </validation-provider>
                        <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes }">
                            <div class="input-group input-group-phone" :class="classes">
                                <input type="tel"
                                    id="input-phone"
                                    placeholder=" "
                                    v-model="phone"
                                    v-mask="{mask: '999999999', placeholder: ' '}"
                                >
                                <label>
                                    Nº Telemóvel
                                </label>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="tw-flex tw-gap-3 tw-text-center tw-justify-between tw-mt-1">
                        <button class="btn-back" @click.prevent="step = 1;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.828" viewBox="0 0 14 14.828"><g transform="translate(-6.5 -6.086)"><path d="M7.5,18h12" transform="translate(0 -4.5)" fill="#16BF5E" stroke="#16BF5E" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path><path d="M18,7.5l6,6-6,6" transform="translate(-4.5 0)" fill="none" stroke="#16BF5E" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></g></svg>
                        </button>
                        <button
                            type="submit"
                            class="btn-cta last"
                            id="submit"
                            :disabled="formLoading"
                        >
                            <span>PEDIR SIMULAÇÃO</span>
                        </button>
                    </div>
                </div>
            </fieldset>
            <div class="bullets tw-flex tw-items-center tw-justify-center tw-gap-2 tw-pt-0 tw-pb-4">
                <div :class="{ 'active' : step >= 1 }"></div>
                <div :class="{ 'active' : step === 2 }"></div>
            </div>
        </form>
    </validation-observer>
</template>

<script>
import axios from 'axios';
import RangeSlider from 'vue-range-slider';
import 'vue-range-slider/dist/vue-range-slider.css';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';
import '@/validations/nif';
import '@/validations/zip';

export default {
    name: 'FormComponent',
    data() {
        return {
            type: 'Gato',
            client: '',
            fullName: '',
            phone: '',
            email: '',
            petInfo: 'Entre 2 e 6 meses',
            nif: '',
            zip: '',
            page: 'A',

            rangeValue: '1',
            step: 1,
            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    components: {
        RangeSlider,
    },
    methods: {
        changePetInfo() {
            switch(this.rangeValue) {
                case 1:
                    this.petInfo = 'Entre 2 e 6 meses';
                    break;
                case 2:
                    this.petInfo = 'Entre 6 meses e 1,5 anos';
                    break;
                case 3:
                    this.petInfo = 'Entre 1,5 anos e 2 anos';
                    break;
                case 4:
                    this.petInfo = 'Entre 2 anos e 4 anos';
                    break;
                case 5:
                    this.petInfo = 'Entre 4 anos e 7 anos';
                    break;
                case 6: 
                    this.petInfo = 'Entre 7 anos e 8 anos';
                    break;
                default:
                    break;
            }
        },
        formSubmit() {
            this.formLoading = true;
            this.$store.state.formName = this.fullName;

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,

                fullName: this.fullName,
                phone: this.phone,
                email: this.email,
                petInfo: this.type + ' - ' + this.petInfo,
                nif: this.nif,
                zip: this.zip,
                page: this.page,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                    fbq('track', 'Lead');
                    gtag('event', 'conversion', {'send_to': 'AW-389361952/TohZCNTbmL0DEKDi1LkB'});

                    // Tiktok pixels
                    !function (w, d, t) {w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};}

                    ttq.load('C6AHHF0N3BRV2G8MFIUG');
                    ttq.page();

                    ttq.load('C7KMT9G68TKN71DEFVA0'); 
                    ttq.page();
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.status == '302') {
                        this.$store.state.formError = true;
                    }
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
@import '~@/assets/scss/partials/_fonts.scss';

.form {
    background-color: $white !important;
    border-radius: 10px;

    @screen lg {
        min-width: 400px;
    }

    fieldset {

        .step {

            .step-2-title {
                @apply tw-mb-3;
                font-family: $font_title;
                font-size: 20px;

                @screen lg {
                    @apply tw-text-3xl tw-mb-4;
                }
            }

            .question {
                @apply tw-w-full;

                p {
                    @apply tw-font-bold tw-mb-2 tw-text-center;
                    font-size: 22px;
                    font-family: $font_title;

                    &.animal {

                        p {
                            text-transform: uppercase !important;
                        }
                    }

                    @screen lg {
                        font-size: 30px;
                    }

                    span {
                        font-size: 17px;

                        @screen lg {
                            font-size: 24px;
                        }
                    }

                    small {
                        font-family: $font_base;
                        @apply tw-font-bold tw-inline-block;
                        font-size: 9.5px;
                        color: $dark-grey;

                        @screen lg {
                            @apply tw-text-lg;
                            width: auto;
                        }
                    }
                }

                &.client {

                    p {
                        @apply tw-text-left tw-mb-0 tw-leading-none;
                    }
                }
            }

            .animal-type {
                @apply tw-cursor-pointer tw-rounded-lg tw-w-full tw-uppercase;
                border: solid 2px $border;
                background-color: $grey-light;
                height: 75px;
                transition: all .15s;

                @screen lg {
                    height: 95px;
                }

                img {
                    @apply tw-pointer-events-none;
                    max-width: 60px;

                    @screen lg {
                        max-width: 80px;
                    }
                }

                small {
                    @apply tw-text-base tw-font-bold;
                    color: $text-light;
                    font-family: $font_title;

                    @screen lg {
                        font-size: 24px;
                        line-height: 0;
                    }
                }

                &.active {
                    background-color: $pink;
                    border-color: $main_color;
                }
            }

            .range-slider-container {

                .range-info {
                    @apply tw-mb-1;

                    p {
                        @apply tw-text-center tw-text-2xl tw-leading-none;
                        color: $text-light;

                        span {
                            @apply tw-relative;
                            top: 7.5px;
                            color: $main_color;
                            font-size: 44px;
                        }
                    }
                }
                
                .range-ticks {
                    @apply tw-mt-5 tw-mx-auto tw-flex tw-items-center tw-justify-center tw-text-center;
                    width: 95%;
                    height: 28px; 
                    
                    >div {
                        @apply tw-h-full;
                        width: 100%;
                        border-right: solid 2px $grey;

                        &:first-of-type {
                            border-left: solid 2px $grey;
                        }
                    }
                }

                span.slider {
                    display: block;
                    width: 100%;

                    .range-slider-inner {

                        .range-slider-rail {
                            height: 10px;
                            background-color: $grey;
                            border-radius: 4px;
                        }

                        .range-slider-fill {
                            height: 10px;
                            background-color: $grey;
                            border-radius: 4px;
                        }

                        .range-slider-knob {
                            box-shadow: none;
                            width: 22px;
                            height: 22px;
                            border: solid 3px $main_color;
                        }
                    }
                }
            }

            .legals {

                h4 {
                    @apply tw-font-bold;
                    font-size: 11px;
                    line-height: 14px;
                }

                p {
                    font-size: 11px;
                    line-height: 14px;
                    @apply tw-font-medium;

                    b, strong {
                        @apply tw-font-bold;
                    }
                }

                a {
                    @apply tw-underline;
                    font-size: 11px;
                    line-height: 14px;
                    color: $main_color;
                }
            }
        }
    }

    .bullets {
        >div {
            @apply tw-bg-white tw-rounded-full tw-w-3 tw-h-3;
            border: solid 2px $border;

            &.active {
                background-color: $border;
            }
        }
    }
}
</style>
